const content = {
  pt: {
    cvHref: process.env.PUBLIC_URL + '/rodrigo-quaresma-cv-pt.pdf',
    nav: {
      links: [
        { href: '#experience', label: 'Experiência' },
        { href: '#about', label: 'Sobre' },
        { href: '#contact', label: 'Contato' },
      ],
      toggleLabel: 'EN',
    },
    hero: {
      name: 'Rodrigo Quaresma',
      roles: ['Product designer', 'IA Builder', 'Airbnb Hoster'],
      tagline: '+20 anos construindo produtos digitais — de TV interativa a martech, sempre pensando em experiência e estória.',
      ctaExperience: 'Ver experiência',
      ctaCV: 'Baixar CV',
    },
    experience: {
      number: '01',
      title: 'Experiência',
      timeline: [
        {
          company: 'netLex',
          role: 'Product Designer',
          period: 'set de 2024 – jun de 2026',
          summary: 'Plataforma SaaS de gestão de contratos (CLM) para empresas. Integrei a primeira squad de Inteligência Artificial da empresa e trabalhei de forma hands-on em soluções com IA, do discovery com clientes à validação com testes de usabilidade, sempre equilibrando automação com transparência e controle do usuário.',
          highlights: [
            'Solução com IA para importar documentos legados no onboarding de clientes corporativos, reduzindo o tempo de implantação e o custo operacional',
            'Fluxos e prompts da primeira versão do chat conversacional da plataforma, integrado ao Slack e ao Microsoft Teams',
            'Evolução da experiência de criação de modelos para geração automatizada de documentos',
            'Componentes do design system com Engenharia e Produto, integrados ao Claude para prototipar com componentes reais',
          ],
        },
        {
          company: 'TaOn',
          role: 'UX/UI Designer',
          period: '2024 – 2025',
          summary: 'Estruturação da experiência do produto, do mapeamento das jornadas ao primeiro design system.',
          highlights: [
            'Mapeamento das jornadas e redesign da versão beta',
            'Primeiro design system do produto, com especificações de componentes e templates',
            'Fluxos e jornadas do back office',
          ],
        },
        {
          company: 'Pipefy',
          role: 'Staff Product Designer',
          period: 'jun de 2022 – ago de 2023',
          summary: 'Experiência incrível na tribo de Product-Led Growth explorando uma rotina de testes contínuos com foco em conversão, adoção e retenção do produto.',
          highlights: [
            'Rotina semanal de testes de hipótese no sign-up, com ganhos de conversão',
            'Onboarding personalizado para três perfis de usuário, melhorando ativação e retenção',
          ],
        },
        {
          company: 'RD Station',
          role: 'Lead Product Designer',
          period: 'jan de 2013 – ago de 2021',
          summary: 'Cheguei na RD como um dos 5 primeiros funcionários e primeiro designer. Acompanhei toda jornada de um start-up recém criada: ideação, operação, tração, scale-up e exit de R$ 2 bi. Durante os quase 9 anos dessa jornada, pude participar da concepção das funcionalidades core do produto de automação de marketing, montagem e gestão do primeiro time de design de produto e estruturação da empresa.',
          highlights: [
            'Contratação e gestão do primeiro time de designers do produto',
            'Concepção e execução da primeira versão do produto',
            'Última versão do criador de Landing Pages e Emails',
            'Código (HTML, CSS e JavaScript) de muitos componentes do primeiro design system',
          ],
          links: [
            { href: 'https://braziljournal.com/totvs-leva-rd-station-por-r-2-bi-valuation-de-ipo/', label: 'Braziljournal: Totvs leva RD Station por R$ 2 bi' },
            { href: 'https://exame.com/tecnologia/por-que-a-totvs-gastou-quase-r-2-bilhoes-na-compra-da-rd-station/', label: 'Exame: Por que a Totvs gastou quase R$ 2 bilhões na compra da RD Station' },
            { href: 'https://blog.eqseed.com/startup-exit-rd-station/', label: 'EqSeed: Startup Exit — a história da RD Station até o valuation de R$2 bi' },
          ],
          featured: true,
        },
        {
          company: 'Vivo (GVT TV)',
          role: 'Senior Product Manager',
          period: 'mai de 2011 – jan de 2013',
          summary: 'Apesar de ser uma grande empresa, quando comecei na GVT senti-me dentro de uma startup. Iniciamos uma unidade de negócios dentro da GVT para construir um novo negócio de TV paga, e eu era responsável por desenvolver novos aplicativos para este produto, atuando como designer e gerente de produto.',
          highlights: [
            'Interface do EPG (Electronic Programming Guide)',
            'App de Instagram e de Facebook para TV',
            'App das Olimpíadas 2012 para TV',
          ],
        },
        {
          company: 'Claro (NET)',
          role: 'Interaction Designer',
          period: 'jan de 2009 – mai de 2011',
          summary: 'Meu primeiro trabalho como designer, dentro do departamento de marketing de uma grande empresa. Pude aprender e me envolver com conceitos de marketing e experimentar ser uma conexão importante entre os departamentos de marketing e engenharia.',
          highlights: [
            'NET NOW, primeiro serviço de vídeo sob demanda (VOD) da operadora',
            'Diversos apps de upsell pela TV',
            'NET música, streaming de música pela TV',
          ],
        },
        {
          company: 'Grupo RBS',
          role: 'Lead Designer',
          period: 'ago de 2002 – dez de 2008',
          summary: 'A RBS foi o lugar no qual pude colocar a teoria em prática e realmente evoluir como profissional. Um amplo portfólio de produtos multimídia, de canais de TV a jornais e rádios, foi uma ótima oportunidade para aplicar novas metodologias de design e testar seu impacto sobre uma audiência de milhões de usuários.',
          highlights: [
            'Gestão do time de design da área de produtos digitais',
            'ClicEsportes, portal de notícias esportivas',
            'Interfaces construídas em código (HTML, CSS e JavaScript)',
          ],
        },
      ],
    },
    about: {
      number: '02',
      title: 'Sobre',
    },
    contents: {
      title: 'Conteúdos',
      intro: 'Um pouco de conteúdo meu ou sobre mim espalhado por aí...',
      articlesLabel: 'artigos',
      talksLabel: 'talks',
      articles: [
        { href: 'https://brasil.uxdesign.cc/por-que-ux-por-rodrigo-quaresma-dd289d41c2d6', label: '"Por que UX?", por Rodrigo Quaresma' },
        { href: 'https://brasil.uxdesign.cc/um-resum%C3%A3o-do-ebai-2011-9a32b1fdfdd5#:~:text=Interatividade%20+%20TV', label: 'Um resumão do Ebai 2011' },
        { href: 'https://faberhaus.com.br/interatividade-e-tv/', label: 'Faberhaus: Interatividade e TV — o quanto de interação queremos quando assistimos algo?' },
      ],
      talks: [
        { href: 'https://medium.com/design-rd/escalando-times-de-ux-podcast-com-rodrigo-quaresma-da-resultados-digitais-a1fda84c627e', label: 'Escalando times de UX: podcast com Rodrigo Quaresma da Resultados Digitais' },
        { href: 'https://www.infoq.com/br/presentations/a-jornada-de-um-ux-designer-dentro-de-uma-startup/', label: 'UX Conf 2016: a jornada de um UX designer dentro de uma startup' },
        { href: 'https://www.slideshare.net/rquaresma/tv-interatividade-9887494', label: '5º EBAI — Encontro Brasileiro de Arquitetura de Informação: TV + interatividade' },
        { href: 'https://www.slideshare.net/rquaresma/a-ux-do-dia-a-dia', label: '4ª Rodada Digital, Estácio de Sá: a UX do dia a dia' },
      ],
    },
    footer: {
      heading: 'Vamos conversar?',
      cvLabel: 'Baixar CV',
      links: [
        { href: 'https://www.linkedin.com/in/rquaresma/', label: 'Linkedin' },
        { href: 'https://github.com/rodrigoquaresma/', label: 'GitHub' },
        { href: 'https://www.flickr.com/photos/rodrigoquaresma/', label: 'Flickr' },
        { href: 'https://airbnb.com.br/p/rosabutia', label: 'Airbnb (superhost)' },
      ],
    },
  },
  en: {
    cvHref: process.env.PUBLIC_URL + '/rodrigo-quaresma-cv-en.pdf',
    nav: {
      links: [
        { href: '#experience', label: 'Experience' },
        { href: '#about', label: 'About' },
        { href: '#contact', label: 'Contact' },
      ],
      toggleLabel: 'PT',
    },
    hero: {
      name: 'Rodrigo Quaresma',
      roles: ['Product designer', 'AI Builder', 'Airbnb Hoster'],
      tagline: '20+ years building digital products — from interactive TV to martech, always thinking about experience and story.',
      ctaExperience: 'View experience',
      ctaCV: 'Download CV',
    },
    experience: {
      number: '01',
      title: 'Experience',
      timeline: [
        {
          company: 'netLex',
          role: 'Product Designer',
          period: 'Sep 2024 – Jun 2026',
          summary: "A SaaS contract lifecycle management (CLM) platform for enterprises. I joined the company's first Artificial Intelligence squad and worked hands-on on AI solutions, from customer discovery to usability testing, always balancing automation with transparency and user control.",
          highlights: [
            'AI solution to import legacy documents during enterprise customer onboarding, reducing implementation time and operational costs',
            "Flows and prompts for the first version of the platform's conversational chat, integrated with Slack and Microsoft Teams",
            'Evolved the template-creation experience for automated document generation',
            'Design system components built with Engineering and Product, integrated with Claude to prototype with real components',
          ],
        },
        {
          company: 'TaOn',
          role: 'UX/UI Designer',
          period: '2024 – 2025',
          summary: "Structured the product experience, from journey mapping to the product's first design system.",
          highlights: [
            'Journey mapping and redesign of the beta version',
            "The product's first design system, with component specs and templates",
            'Back-office flows and journeys',
          ],
        },
        {
          company: 'Pipefy',
          role: 'Staff Product Designer',
          period: 'Jun 2022 – Aug 2023',
          summary: "A great experience within the Product-Led Growth tribe, running a continuous testing routine focused on the product's conversion, adoption, and retention.",
          highlights: [
            'Weekly hypothesis-testing routine on sign-up, improving conversion',
            'Onboarding tailored to three user profiles, improving activation and retention',
          ],
        },
        {
          company: 'RD Station',
          role: 'Lead Product Designer',
          period: 'Jan 2013 – Aug 2021',
          summary: "I joined RD as one of the first 5 employees and the company's first designer. I followed the whole journey of a brand-new startup: ideation, operation, traction, scale-up, and a R$2B exit. Over almost 9 years, I helped shape the core features of the marketing automation product, built and led the first product design team, and helped structure the company.",
          highlights: [
            'Hired and managed the first product design team',
            "Shaped and shipped the product's first version",
            'Latest version of the Landing Page and Email builder',
            'Wrote the code (HTML, CSS and JavaScript) for many components of the first design system',
          ],
          links: [
            { href: 'https://braziljournal.com/totvs-leva-rd-station-por-r-2-bi-valuation-de-ipo/', label: 'Braziljournal: Totvs acquires RD Station for R$2B' },
            { href: 'https://exame.com/tecnologia/por-que-a-totvs-gastou-quase-r-2-bilhoes-na-compra-da-rd-station/', label: 'Exame: Why Totvs spent almost R$2 billion on RD Station' },
            { href: 'https://blog.eqseed.com/startup-exit-rd-station/', label: "EqSeed: Startup Exit — RD Station's story up to its R$2B valuation" },
          ],
          featured: true,
        },
        {
          company: 'Vivo (GVT TV)',
          role: 'Senior Product Manager',
          period: 'May 2011 – Jan 2013',
          summary: 'Even though it was a large company, joining GVT felt like joining a startup. We launched a new business unit within GVT to build a pay-TV business, and I was responsible for developing new applications for it, acting as both designer and product manager.',
          highlights: [
            'EPG (Electronic Programming Guide) interface',
            'Instagram and Facebook apps for TV',
            '2012 Olympics app for TV',
          ],
        },
        {
          company: 'Claro (NET)',
          role: 'Interaction Designer',
          period: 'Jan 2009 – May 2011',
          summary: 'My first job as a designer, inside the marketing department of a large company. I learned about and got involved with marketing concepts, and got to be an important connection between the marketing and engineering departments.',
          highlights: [
            "NET NOW, the carrier's first video-on-demand (VOD) service",
            'Several TV upsell apps',
            'NET música, a music streaming service for TV',
          ],
        },
        {
          company: 'Grupo RBS',
          role: 'Lead Designer',
          period: 'Aug 2002 – Dec 2008',
          summary: 'RBS was the place where I got to put theory into practice and really grow as a professional. A broad portfolio of multimedia products, from TV channels to newspapers and radio stations, was a great opportunity to apply new design methodologies and test their impact on an audience of millions.',
          highlights: [
            'Led the design team for the digital products area',
            'ClicEsportes, a sports news portal',
            'Built interfaces in code (HTML, CSS and JavaScript)',
          ],
        },
      ],
    },
    about: {
      number: '02',
      title: 'About',
    },
    contents: {
      title: 'Writing',
      intro: 'A bit of content by or about me, scattered around the web...',
      articlesLabel: 'articles',
      talksLabel: 'talks',
      articles: [
        { href: 'https://brasil.uxdesign.cc/por-que-ux-por-rodrigo-quaresma-dd289d41c2d6', label: '"Por que UX?", por Rodrigo Quaresma (PT)' },
        { href: 'https://brasil.uxdesign.cc/um-resum%C3%A3o-do-ebai-2011-9a32b1fdfdd5#:~:text=Interatividade%20+%20TV', label: 'Um resumão do Ebai 2011 (PT)' },
        { href: 'https://faberhaus.com.br/interatividade-e-tv/', label: 'Faberhaus: Interatividade e TV (PT)' },
      ],
      talks: [
        { href: 'https://medium.com/design-rd/escalando-times-de-ux-podcast-com-rodrigo-quaresma-da-resultados-digitais-a1fda84c627e', label: 'Escalando times de UX: podcast (PT)' },
        { href: 'https://www.infoq.com/br/presentations/a-jornada-de-um-ux-designer-dentro-de-uma-startup/', label: 'UX Conf 2016: a jornada de um UX designer (PT)' },
        { href: 'https://www.slideshare.net/rquaresma/tv-interatividade-9887494', label: '5º EBAI: TV + interatividade (PT)' },
        { href: 'https://www.slideshare.net/rquaresma/a-ux-do-dia-a-dia', label: '4ª Rodada Digital: a UX do dia a dia (PT)' },
      ],
    },
    footer: {
      heading: "Let's talk?",
      cvLabel: 'Download CV',
      links: [
        { href: 'https://www.linkedin.com/in/rquaresma/', label: 'Linkedin' },
        { href: 'https://github.com/rodrigoquaresma/', label: 'GitHub' },
        { href: 'https://www.flickr.com/photos/rodrigoquaresma/', label: 'Flickr' },
        { href: 'https://airbnb.com.br/p/rosabutia', label: 'Airbnb (superhost)' },
      ],
    },
  },
};

export default content;
